import store from '../store'
import router from "../router"

export default {
  namespaced: true,
  state: {
    modal_login: false,
    cart_modal: false,
    user_profile: null,
    eventTutorial: true
  },
  mutations: {
    setLoginModal(state, modal_login) {
      state.modal_login = modal_login
    },
    setCart(state, cart_modal) {
      state.cart_modal = cart_modal
    },
    setUser(state, user_profile) {
      state.user_profile = user_profile
    },
    setEventTutorial(state, display) {
      state.eventTutorial = display
    }
  },
  actions: {
    setLoginModal({commit}, modal_login) {
      commit('setLoginModal', modal_login)
    },
    setCart({commit}, cart_modal) {
      commit('setCart', cart_modal)
    },
    closeShoppingCart({commit}, cart_modal) {
      commit('setCart', false)
    },
    openShoppingCart({commit}, cart_modal) {
      commit('setCart', true)
    },
    setUser({commit}, user_profile) {
      commit('setUser', user_profile)
    },
    showEventTutorial({commit}) {
      commit('setEventTutorial', true)
    },
    hideEventTutorial({commit}) {
      commit('setEventTutorial', false)
    }
  },
  getters: {
    getModalLogin(state) {
      return state.modal_login
    },
    isOpenShoppingCart(state) {
      return state.cart_modal
    },
    getUser(state) {
      return state.user_profile
    },
    displayEventTutorial(state) {
      return state.eventTutorial
    }    
  }
}
